const apiendpoint =  {
  login:"/users/auth/jwt/create",
  getProjects:"/projects/",
  getWorkspaces:"/workspaces/",
  fetch:"/users/account/",
  getTasks:"/task/",  
  getOrganizations:"/organizations/",
  notification:"/notifications/",
  getLanguages:"/users/languages/",
  getDatasets:"/data/",
  annotations:"/annotation/",
  getUsers:"/users/",
  changepassword:"/users/account/",
  authUsers:"/users/auth/users/",
  authUser:"/users/auth/users/",
  functions:"/functions/",
  Glossary:"/v1/",
  onboarding: "onboarding/"
};

export default apiendpoint;